<template>
    <div id="box-send-request" :class="['container-fluid text-center py-2 box-fixed box-white', (countSelectedHours > 0) ? '' : 'd-none']">
        <p v-html="bookingRequestDetail"></p>

        <label for="meetingtype">Meeting type</label>
        <select v-model="meetingtype" name="meetingtype" id="meetingtype" class="form-select" aria-label="Select type of meeting">
            <option value="" selected>Select type of meeting*</option>
            <option value="Customer meeting">Customer meeting</option>
            <option value="OEM meeting">OEM meeting</option>
            <option value="Supplier meeting">Supplier meeting</option>
            <option value="Press meeting">Press meeting</option>
            <option value="Marketing & Sales meeting">Marketing & Sales meeting</option>
            <option value="Generic meeting">Other</option>
        </select>

        <label for="meetingtype">Attending participant</label>
        <select v-model="attendantId" name="attendantId" id="attendantId" class="form-select" aria-label="Select attendant user">
            <option value="" selected>Select attendee if not You</option>
            <option v-for="(participant, index) in participants" :key="index" :value="participant.id">{{ participant.title }}</option>
        </select>

        <div v-if="countSelectedHours > 2" class="alert alert-danger text-center">
            <strong>You can reserve maximum 1 hour range!</strong>
        </div>

        <button type="button" class="btn btn-secondary me-3" @click="hidePopup">
            <span>Cancel</span>
            <i class="fa fa-times"></i>
        </button>

        <button type="button" :class="[(!btnEnabled) ? 'disabled' : '', 'btn btn-coesia']" @click="sendRequest">
            Send Booking request
            <i class="far fa-paper-plane" v-if="btnEnabled"></i>
            <i class="fa fa-times" v-if="!btnEnabled"></i>
        </button>
    </div>
  
  <div v-if="requestSent" class="container-fluid alert alert-success text-center box-fixed">
    <strong>Request sent correctly!</strong>
  </div>

  <div v-if="requestError" class="container-fluid alert alert-danger text-center box-fixed">
    <strong v-html="requestError"></strong>
  </div>

  <h1 v-if="eventItem">
    <router-link :to="'/events/'+ eventItem.id">
      <i class="fas fa-long-arrow-alt-right"></i> {{ eventItem.title }}
    </router-link>
  </h1>
  
  <OfflineMode />

  <div class="container-fluid container-lg" v-if="roomItem">
    <h2 class="text-center">{{ roomItem.title }}</h2>

    <div>
      <div v-if="roomItem.stand"><span class="font-bold">Stand:</span> {{ roomItem.stand }}</div>
      <div v-if="roomItem.pax"><span class="font-bold">Capacity:</span> max {{ roomItem.pax }} pax</div>
      <div v-if="roomItem.text">
        <span class="font-bold">Info: </span> 
        <span v-html="roomItem.text"></span>
      </div>
      
      <div v-if="canEdit && offlineMode" class="alert alert-warning mt-2 text-center">
        <i class="fa fa-exclamation-circle me-2"></i> You need to be online to reserve a meeting room!
      </div>
      
      <div class="accordion" v-if="roomItem.editable">
        <h3>{{ dayItem.title }}</h3>
      </div>
      
      <div class="list-group mb-4" v-if="roomItem.editable">
        <div v-for="(item, index) in roomItem.availableHours"
          :key="index">

          <CalendarHour v-if="!roomItem.engagedHours.find(event => event.hour === item.start)"
            :id="id"
            :day="dayItem"
            :room="roomItem"
            :hour="item.start"
            :end="item.end" 
            :index="index" 
						:editable="canEdit" />

          <div v-if="user && roomItem.engagedHours.find(event => event.hour === item.start && (event.userId === user.id || event.attendantId === user.id))" class="list-group-item">
            <div class="d-flex w-100 justify-content-between">
              <span>{{ item.start }} - {{ item.end }}</span>
              <strong class="text-success">{{ roomItem.engagedHours.find(event => event.hour === item.start && (event.userId === user.id || event.attendantId === user.id)).type }} Booked!</strong>
              <a v-if="!offlineMode" href="#" @click="removeBooking(roomItem.id, dayItem.id, item.start)"><i class="fa fa-trash"></i></a>
            </div>
          </div>

          <div v-if="user && roomItem.engagedHours.find(event => event.hour === item.start && event.userId !== user.id && event.attendantId !== user.id)" class="list-group-item disabled">
            <div class="d-flex w-100 justify-content-between">
              <span>{{ item.start }} - {{ item.end }}</span>
              <small>Not available</small>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import CalendarHour from './CalendarHour.vue';
import OfflineMode from '../OfflineMode';

export default {
  name: 'CalendarRoom',
  props: ['id', 'roomid', 'dayid'],
  data() {
    return {
      meetingtype: '',
      attendantId: '',
      requestSent: false,
      requestError: null
    }
  },
  computed: {
      ...mapGetters([
          'getSelectedHours',
          'countSelectedHours',
          'user',
          'token',
          'offlineMode',
          'contactType'
    ]),
    participants() {
      return this.$store.getters.contactItemFromType(Number(this.id), 'participants');
    },
		applicantName() {
			let user = this.$store.getters.contactItemFromId(Number(this.user.id));
			return user.title
		},
		attendantName() {
			if (this.attendantId == '') return ''
			let user = this.$store.getters.contactItemFromId(Number(this.attendantId));
			return user.title
		},
    eventItem() {
      return this.$store.getters.fairItemFromId(Number(this.id));
    },
    roomItem() {
      let RoomItem = this.$store.getters.roomItemFromId(this.dayid, this.roomid);
      if (RoomItem) {
        // definisco l'intervallo di orari disponibili nella giornata
        let availableHours = ['08:00', '08:30', '09:00', '09:30', '10:00', '10:30', '11:00', '11:30', '12:00', '12:30', '13:00', '13:30', '14:00', '14:30', '15:00', '15:30', '16:00', '16:30', '17:00', '17:30', '18:00', '18:30', '19:00', '19:30', '20:00', '20:30']
        let availableHoursInt = ['08:00 AM', '08:30 AM', '09:00 AM', '09:30 AM', '10:00 AM', '10:30 AM', '11:00 AM', '11:30 AM', '12:00 AM', '12:30 AM', '01:00 PM', '01:30 PM', '02:00 PM', '02:30 PM', '03:00 PM', '03:30 PM', '04:00 PM', '04:30 PM', '05:00 PM', '05:30 PM', '06:00 PM', '06:30 PM', '07:00 PM', '07:30 PM', '08:00 PM', '08:30 PM']
        let startHour = RoomItem.startHour;
        let endHour = RoomItem.endHour;
        let arrAvailableHours = [];
        let index = 0
        availableHours.forEach(function(hour) {
          if (hour >= startHour && hour < endHour) {
            //let end = availableHours[index+1]
            //arrAvailableHours.push({'start': hour, 'end': end});
            let start = availableHoursInt[index]
            let end = availableHoursInt[index+1]
            arrAvailableHours.push({'start': start, 'end': end});
          }
          index++
        });
        RoomItem.availableHours = arrAvailableHours;
        // memorizzo gli orari impegnati
        let arrEngagedHours = [];
        if (RoomItem.events) {
          RoomItem.events.forEach(function(event) {
            availableHours.forEach(function(hour) {
              if (hour >= event.startHour && hour < event.endHour) {
								let index = availableHours.indexOf(hour)
								let hourInt = availableHoursInt[index]
                arrEngagedHours.push({'hour': hourInt, 'userId': event.userId, 'attendantId': event.attendantId, 'type': event.type});
              }
            });
          });
        }
        RoomItem.engagedHours = arrEngagedHours;
        //console.log(RoomItem);
      }
      return RoomItem;
    },
    dayItem() {
      return this.$store.getters.roomItemsFromDay(this.dayid)
    },
    canEdit() {
			let ongoing = this.eventItem.ongoing
			if (!ongoing) return false
      if (this.user && this.user.levelId > 1) {
				let userState = this.contactType(this.id, this.user.id)
				if (!userState) return false
				if (userState.isparticipant) return true
				if (userState.isstaff) return true
				return false
			}
      if (this.user && this.user.levelId == 1) return true
      return false
    },
    /*engaged(start) {
      return this.roomItem.engagedHours.find(event => event.hour === start && event.userId === this.user.id)
    },*/
    btnEnabled() {
      if (this.countSelectedHours > 2) {
        return false
      } else {
        let valid = (this.meetingtype !== '') ? true : false
        return valid
      }
    },
    bookingRequestDetail () {
      if (this.getSelectedHours.length == 0) return ''
      let room = this.getSelectedHours[0].room;
      let day = this.getSelectedHours[0].day;
      let html = "<h3>Your request</h3> \
      <strong>"+ room +", "+ day +"</strong>: ";
      // prelevo dettaglio orari
      let requestDetails = this.$store.getters.getRequestDetails
      for (let i = 0; i < requestDetails.length; i++) {
        let startHour = requestDetails[i].start;
        let endHour = requestDetails[i].end;
        html += startHour +"/"+ endHour
        if (i < requestDetails.length - 1) html += " - "
      }
      return html;
    }
  },
  methods: {
    sendRequest() {
      const requestDetails = { requestHours: this.getSelectedHours, requestDetails: this.$store.getters.getRequestDetails, meetingtype: this.meetingtype, 'userId': this.user.id, 'attendantId': this.attendantId }
      // reset
      this.resetSelected()
      this.meetingtype = ''
      this.attendantId = ''
      // SEND REQUEST
      this.$store.dispatch('sendRequest', requestDetails).then((response) => {
        console.log('sendRequest response', response)
        if (!response.requestSent) {
          this.requestError = response.error;
        } else {
          if (response.error) {
            this.requestError = 'Could not save all your bookings!<br>'+ response.error;
            setTimeout(this.hideConfirm, 10000)
          } else {
            this.requestSent = true;
            setTimeout(this.hideConfirm, 3000)
          }
        }
      })
    },
    resetSelected() {
        this.$store.dispatch('removeAllRequests');
        document.querySelectorAll('.form-check-input').forEach(item => {
            item.checked = false;
        });
        document.querySelectorAll('.list-group-item-primary').forEach(item => {
            item.classList.remove("list-group-item-primary");
        });
    },
    hideConfirm() {
      this.requestSent = false;
      this.requestError = null;
    },
      hidePopup(e) {
          e.preventDefault()
          this.resetSelected()
      },
    removeBooking(roomId, dayId, hour) {
      var confirm = window.confirm("Are you sure that you want to delete your booking request?");
      if (confirm) {
        // cancellazione prenotazione da database
        const bookingItem = {'fairId': Number(this.id), 'room': this.roomItem.title, 'day': this.dayItem.title, 'roomId': roomId, 'dayId': dayId, 'hour': hour, 'userId': this.user.id};
        this.$store.dispatch('removeBooking', bookingItem);
      }
    }
  },
  components: {
    CalendarHour,
    OfflineMode
  }
}
</script>

<style scoped>
  .accordion {
    border-top: 1px solid #DA052C;
    margin: 1.5rem 0 0;
  }
  .accordion h3 {
    text-align: center;
    margin: 12px auto;
  }

  #meetingtype, 
	#attendantId {
    width: auto;
    margin: 0 auto 1rem;
  }
</style>
